<template>
  <v-btn :text="!outlined" dark outlined color="secondary" @click="handleDownload">
    <v-icon dark>mdi-file-excel-outline</v-icon>
    Exportar a Excel
  </v-btn>
  <!-- <v-menu
    v-model="exportDialog"
    :close-on-content-click="false"
    :nudge-width="200"
    origin="top right"
    transition="scale-transition"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn text dark medium color="secondary" v-on="on">
        <v-icon dark>mdi-file-excel-outline</v-icon>
        Exportar
      </v-btn>
    </template>
    <v-card max-width="500">
      <v-toolbar dense :elevation="0" color="background darken-1">
        <v-icon class="secondary--text mr-1">mdi-file-excel-outline</v-icon>
        <v-toolbar-title>
          {{ $Amplify.I18n.get("Exportar a Excell") }}</v-toolbar-title
        >

        <v-spacer></v-spacer>
        <v-btn text icon color="secondary" @click.stop="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <ValidationProvider
          name="nombre del archivo"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            v-model="filename"
            autofocus
            label="Nombre del archivo"
            :error-messages="errors"
            :success="valid"
            outlined
          >
          </v-text-field>
        </ValidationProvider>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey darken-1" @click="handleDownload"
          >Exportar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-menu> -->
</template>

<script>


export default {
  name: "Excell",
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    fieldValues: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      downloadLoading: false,
      exportDialog: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      logger: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(excel => {
        const list = this.items;
        const data = this.formatJson(this.fieldValues, list);
        excel.export_json_to_excel({
          header: this.headers,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return this.parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },

    close: function() {
      this.exportDialog = false;
    },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (typeof time === "string" && /^[0-9]+$/.test(time)) {
          time = parseInt(time);
        }
        if (typeof time === "number" && time.toString().length === 10) {
          time = time * 1000;
        }
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
          return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
